import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=f2d5e0e4&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=f2d5e0e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d5e0e4",
  null
  
)

component.options.__file = "Contacts.vue"
export default component.exports